import { render, staticRenderFns } from "./ConfigureDocumentUsers.vue?vue&type=template&id=2f697fea&scoped=true"
import script from "./ConfigureDocumentUsers.vue?vue&type=script&lang=js"
export * from "./ConfigureDocumentUsers.vue?vue&type=script&lang=js"
import style0 from "./ConfigureDocumentUsers.vue?vue&type=style&index=0&id=2f697fea&prod&lang=scss"
import style1 from "./ConfigureDocumentUsers.vue?vue&type=style&index=1&id=2f697fea&prod&lang=scss&scoped=true"
import style2 from "./ConfigureDocumentUsers.vue?vue&type=style&index=2&id=2f697fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f697fea",
  null
  
)

export default component.exports